// Parâmetros de modelo de mensagem são nomeados ({{nome_cliente}}); os provedores
// (Meta/360dialog) só conhecem os posicionais ({{1}}, {{2}}...). A tradução é feita
// na fronteira com o provedor, pela ordem de ocorrência no texto. Modelos antigos,
// numerados de 1 a N, traduzem para eles mesmos.

const REGEX_PARAMETRO = /{{([^{}]+)}}/g;

/** Letras minúsculas sem acento, números e "_" */
const REGEX_NOME_PARAMETRO = /^[a-z0-9_]+$/;

/** Nomes dos parâmetros na ordem em que aparecem no texto, com repetições */
function ocorrenciasParametros(texto: string | null | undefined): string[] {
  return [...(texto ?? '').matchAll(REGEX_PARAMETRO)].map((m) => m[1]);
}

/** Nomes distintos, na ordem da primeira ocorrência */
export function nomesParametros(texto: string | null | undefined): string[] {
  return [...new Set(ocorrenciasParametros(texto))];
}

/** Nomes que não seguem REGEX_NOME_PARAMETRO */
export function nomesParametrosInvalidos(texto: string | null | undefined): string[] {
  return nomesParametros(texto).filter((nome) => !REGEX_NOME_PARAMETRO.test(nome));
}

/**
 * Texto com os parâmetros trocados por {{1}}..{{N}} e o nome de cada posição.
 * Nome repetido ocupa uma posição por ocorrência, repetindo o valor.
 */
export function modeloPosicional(texto: string): { texto: string; ordem: string[] } {
  const ordem: string[] = [];
  const posicional = texto.replace(REGEX_PARAMETRO, (_, nome: string) => {
    ordem.push(nome);
    return `{{${ordem.length}}}`;
  });
  return { texto: posicional, ordem };
}
